import { Checkbox } from '@mui/material';
import { Role } from '../../../../types/Role';

const makeRolePolicyColumn = (role: Role, handleChange) => {
  return [
    {
      id: 'selection',
      size: 190,
      header: 'Assigned',
      cell: ({ row }: any) => (
        <Checkbox
          onChange={async (event) => await handleChange(event, row.original.id)}
          checked={role.policyIds.includes(row.original.id)}
          defaultChecked={role.policyIds.includes(row.original.id)}
          style={{ padding: 0 }}
        />
      ),
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 250,
    },
  ] as Array<any>;
};
export default makeRolePolicyColumn;
